import { render } from "./SectionEditor.vue?vue&type=template&id=5d23fbb9"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"
script.render = render

export default script